export const SET_LOADING_GENERAL = "V1_SET_LOADING_GENERAL";
export const UNSET_LOADING_GENERAL = "V1_UNSET_LOADING_GENERAL";

export const SET_LOADING_APPLICATION = "V1_SET_LOADING_APPLICATION";
export const UNSET_LOADING_APPLICATION = "V1_UNSET_LOADING_APPLICATION";

export const SET_LOADING_BILLING = "V1_SET_LOADING_BILLING";
export const UNSET_LOADING_BILLING = "V1_UNSET_LOADING_BILLING";

export const SET_LOADING_EMPLOYEE = "V1_SET_LOADING_EMPLOYEE";
export const UNSET_LOADING_EMPLOYEE = "V1_UNSET_LOADING_EMPLOYEE";

export const SET_LOADING_EMPLOYER = "V1_SET_LOADING_EMPLOYER";
export const UNSET_LOADING_EMPLOYER = "V1_UNSET_LOADING_EMPLOYER";

export const SET_LOADING_REMARK = "V1_SET_LOADING_REMARK";
export const UNSET_LOADING_REMARK = "V1_UNSET_LOADING_REMARK";

export const SET_LOADING_GROUP = "V1_SET_LOADING_GROUP";
export const UNSET_LOADING_GROUP = "V1_UNSET_LOADING_GROUP";

export const SET_LOADING_PAYROLL = "V1_SET_LOADING_PAYROLL";
export const UNSET_LOADING_PAYROLL = "V1_UNSET_LOADING_PAYROLL";

export const SET_LOADING_COMPANY = "V1_SET_LOADING_COMPANY";
export const UNSET_LOADING_COMPANY = "V1_UNSET_LOADING_COMPANY";

export const SET_LOADING_DASHBOARD_ALL = "V1_SET_LOADING_DASHBOARD_ALL";
export const UNSET_LOADING_DASHBOARD_ALL = "V1_UNSET_LOADING_DASHBOARD_ALL";

export const SET_LOADING_DASHBOARD_DAILY = "V1_SET_LOADING_DASHBOARD_DAILY";
export const UNSET_LOADING_DASHBOARD_DAILY = "V1_UNSET_LOADING_DASHBOARD_DAILY";

export const SET_LOADING_DASHBOARD_MONTHLY = "V1_SET_LOADING_DASHBOARD_MONTHLY";
export const UNSET_LOADING_DASHBOARD_MONTHLY = "V1_UNSET_LOADING_DASHBOARD_MONTHLY";